// Selects the legacy single-tenant config or the partners multi-tenant config
// based on VITE_AUTH_MODE. Default 'legacy' keeps the existing
// guardian.iuvotech.com build unchanged. Tree-shaking note: only the partners
// build elides the unused module (because .env.partners pins VITE_AUTH_MODE
// as a build-time constant Rollup can fold the ternary on). The default
// production build leaves VITE_AUTH_MODE unset, so the runtime '?? legacy'
// fallback blocks constant folding and both modules end up in the bundle.
// Acceptable bloat (~110 lines of MSAL config) — revisit if it grows.
import * as legacy from './auth.legacy'
import * as partners from './auth.partners'

const authMode = (import.meta.env.VITE_AUTH_MODE as 'legacy' | 'partners' | undefined) ?? 'legacy'
const impl = authMode === 'partners' ? partners : legacy

export const msalConfig = impl.msalConfig
export const loginRequest = impl.loginRequest
export const tokenRequest = impl.tokenRequest
export const apiRequest = impl.apiRequest
export const graphConfig = impl.graphConfig
